import { Outlet, Link, useLocation } from 'react-router-dom';
import { Home, Search, ChefHat, MessageCircle, User } from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { href: '/', icon: Home, label: 'Início' },
  { href: '/buscar', icon: Search, label: 'Buscar' },
  { href: '/cozinhar', icon: ChefHat, label: 'Cozinhar' },
  { href: '/chat', icon: MessageCircle, label: 'Chat' },
  { href: '/perfil', icon: User, label: 'Perfil' },
];

export function MainLayout() {
  const location = useLocation();
  
  return (
    <div className="flex min-h-screen flex-col bg-background">
      {/* Main content */}
      <main className="flex-1 pb-20">
        <Outlet />
      </main>
      
      {/* Bottom navigation */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <div className="mx-auto flex h-16 max-w-lg items-center justify-around px-4">
          {navItems.map(({ href, icon: Icon, label }) => {
            const isActive = location.pathname === href || 
              (href !== '/' && location.pathname.startsWith(href));
            
            return (
              <Link
                key={href}
                to={href}
                className={cn(
                  'flex flex-col items-center gap-1 rounded-lg px-3 py-2 text-xs font-medium transition-colors',
                  isActive
                    ? 'text-primary'
                    : 'text-muted-foreground hover:text-foreground'
                )}
              >
                <Icon className={cn('h-5 w-5', isActive && 'text-primary')} />
                <span>{label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}

